webpackJsonp([96961042003272],{

/***/ 432:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    margin-bottom: 160px;\n  '], ['\n    margin-bottom: 160px;\n  ']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n      margin-bottom: ', ';\n    '], ['\n      margin-bottom: ', ';\n    ']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n      padding: 0 0 0 30px;\n    '], ['\n      padding: 0 0 0 30px;\n    ']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n        padding-right: 100px;\n        padding-left: 80px;\n      '], ['\n        padding-right: 100px;\n        padding-left: 80px;\n      ']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n      max-width: 125%;\n      margin-left: -100px;\n    '], ['\n      max-width: 125%;\n      margin-left: -100px;\n    ']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n    display:none;\n  '], ['\n    display:none;\n  ']);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactMarkdown = __webpack_require__(132);
	
	var _reactMarkdown2 = _interopRequireDefault(_reactMarkdown);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styles = __webpack_require__(6);
	
	var _shared = __webpack_require__(7);
	
	var _components = __webpack_require__(435);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var sp = _styles.theme.sp,
	    colors = _styles.theme.colors;
	
	
	var Wrapper = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'PagePage__Wrapper'
	})(['background:#f8fbff;margin-bottom:100px;', ';'], _styles.media.laptop(_templateObject));
	
	var Content = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'PagePage__Content'
	})(['font-size:20px;font-weight:400;margin:0 auto;h2{margin-bottom:', ';}h3{margin-bottom:', ';}p,ul,ol{counter-reset:item;line-height:1.4;font-weight:400;margin-bottom:', ';', ';}ol,ul{padding:0;', ';}ul li{position:relative;list-style:none;padding-left:40px;margin-bottom:', ';&::before{position:absolute;top:15px;left:0;width:20px;height:2px;background-color:', ';content:\'\';}}ol li{position:relative;counter-increment:item;list-style:none;padding-left:40px;margin-bottom:', ';&::before{position:absolute;top:0;left:0;content:counters(item,\'\') \'.\';color:', ';width:20px;}}a{transition:all 0.3s;text-decoration:none;color:', ';}a:hover{color:', ';}caption{display:inline-block;width:100%;text-align:center;margin-bottom:', ';font-size:14px;font-style:italic;font-weight:500;color:', ';}blockquote{margin:', ' 0 100px;border-left:', ' solid ', ';p{margin:0;padding-right:40px;padding-left:40px;width:100%;font-size:24px;line-height:36px;font-style:italic;font-weight:500;color:', ';', ';}}.embed-container{margin-bottom:', ';}img{display:block;max-width:100%;margin-bottom:', ';', ';}'], sp.xl, sp.m, sp.xl, _styles.media.tablet(_templateObject2, sp.xxl), _styles.media.tablet(_templateObject3), sp.s, colors.blue, sp.s, colors.blue, colors.blue, colors.blue, sp.xxl, colors.grey, sp.max, sp.xxs, colors.blue, colors.grey, _styles.media.tablet(_templateObject4), sp.xxl, sp.xxl, _styles.media.desktop(_templateObject5));
	
	var MobileHeader = /*#__PURE__*/_styledComponents2.default.img.withConfig({
	  displayName: 'PagePage__MobileHeader'
	})(['max-width:100%;margin-bottom:', ';', ';'], sp.l, _styles.media.tablet(_templateObject6));
	
	function PagePage(_ref) {
	  var data = _ref.data;
	  var heading = data.heading,
	      subheading = data.subheading,
	      slug = data.slug,
	      content = data.content,
	      headerBackgroundImage = data.headerBackgroundImage,
	      heroTypingValues = data.heroTypingValues,
	      pardotEmbedCode = data.pardotEmbedCode,
	      seoTitle = data.seoTitle,
	      seoKeywords = data.seoKeywords,
	      seoDescription = data.seoDescription;
	
	
	  return _react2.default.createElement(
	    Wrapper,
	    null,
	    _react2.default.createElement(_shared.SeoTags, {
	      title: seoTitle,
	      keywords: seoKeywords,
	      description: seoDescription && seoDescription.seoDescription
	    }),
	    _react2.default.createElement(_components.Header, {
	      image: headerBackgroundImage,
	      heading: heading,
	      subheading: subheading,
	      slug: slug,
	      heroTypingValues: heroTypingValues
	    }),
	    _react2.default.createElement(MobileHeader, {
	      src: headerBackgroundImage.responsiveResolution ? headerBackgroundImage.responsiveResolution.src : headerBackgroundImage.file.url
	    }),
	    _react2.default.createElement(
	      _shared.Container,
	      { narrow: true },
	      _react2.default.createElement(
	        Content,
	        null,
	        _react2.default.createElement(_reactMarkdown2.default, { source: content.content, escapeHtml: false }),
	        _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: pardotEmbedCode } })
	      )
	    )
	  );
	}
	
	PagePage.propTypes = {
	  data: _propTypes2.default.shape({}).isRequired
	};
	
	exports.default = PagePage;
	module.exports = exports['default'];

/***/ }),

/***/ 433:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    background-size: cover;\n    background-position: left;\n    background-image: url(\'', '\');\n    background-repeat: no-repeat;\n    height: 400px;\n  '], ['\n    background-size: cover;\n    background-position: left;\n    background-image: url(\'', '\');\n    background-repeat: no-repeat;\n    height: 400px;\n  ']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n      margin: 0 auto;\n      line-height: 37px;\n      width: 50%;\n    '], ['\n      margin: 0 auto;\n      line-height: 37px;\n      width: 50%;\n    ']);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styles = __webpack_require__(6);
	
	var _theme = __webpack_require__(14);
	
	var _mixins = __webpack_require__(17);
	
	var _mixins2 = _interopRequireDefault(_mixins);
	
	var _shared = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var StyledHeader = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'Header__StyledHeader'
	})(['display:flex;justify-content:center;flex-direction:column;margin-bottom:', ';padding:0 ', ';height:320px;', ';'], _theme.sp.xl, _theme.sp.m, _styles.media.tablet(_templateObject, function (props) {
	  return props.src;
	}));
	
	var Headings = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'Header__Headings'
	})(['', ';margin-bottom:', ';margin-top:20px;text-align:center;'], _mixins2.default.heroText, _theme.sp.xl);
	
	var Subheading = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'Header__Subheading'
	})(['h3{', ';font-size:24px;}'], _styles.media.tablet(_templateObject2));
	
	function Header(_ref) {
	  var heading = _ref.heading,
	      subheading = _ref.subheading,
	      slug = _ref.slug,
	      image = _ref.image,
	      heroTypingValues = _ref.heroTypingValues;
	
	  var breadcrumbs = [{
	    name: 'Home',
	    link: '/'
	  }, {
	    name: heading,
	    link: '/' + slug
	  }];
	  return _react2.default.createElement(
	    StyledHeader,
	    {
	      src: image.responsiveResolution ? image.responsiveResolution.src : image.file.url
	    },
	    _react2.default.createElement(_shared.Breadcrumbs, { breadcrumbs: breadcrumbs }),
	    _react2.default.createElement(
	      Headings,
	      null,
	      heroTypingValues ? _react2.default.createElement(_shared.TypingHero, { heading: heading, lines: heroTypingValues.split(',') }) : _react2.default.createElement(_shared.StaticHero, { heading: heading }),
	      _react2.default.createElement(
	        Subheading,
	        null,
	        _react2.default.createElement(
	          'h3',
	          null,
	          subheading
	        )
	      )
	    )
	  );
	}
	
	Header.propTypes = {
	  heading: _propTypes2.default.string.isRequired,
	  subheading: _propTypes2.default.string.isRequired,
	  slug: _propTypes2.default.string.isRequired,
	  image: _propTypes2.default.shape({}).isRequired,
	  heroTypingValues: _propTypes2.default.string.isRequired
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 434:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Header = __webpack_require__(433);
	
	var _Header2 = _interopRequireDefault(_Header);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _Header2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 435:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Header = undefined;
	
	var _Header = __webpack_require__(434);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Header = _Header2.default;

/***/ }),

/***/ 436:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PagePage = __webpack_require__(432);
	
	var _PagePage2 = _interopRequireDefault(_PagePage);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _PagePage2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 575:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PagePage = __webpack_require__(436);
	
	var _PagePage2 = _interopRequireDefault(_PagePage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Page(_ref) {
	  var pathContext = _ref.pathContext;
	
	  return _react2.default.createElement(_PagePage2.default, { data: pathContext });
	}
	
	Page.propTypes = {
	  pathContext: _propTypes2.default.shape({}).isRequired
	};
	
	exports.default = Page;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-page-js-522cfba8aa404c224632.js